import type { FirebaseApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAek0ffyMts92qP6oYbwcnDYJxdUIb5X7I",
  authDomain: "nvpgames-landing.firebaseapp.com",
  projectId: "nvpgames-landing",
  storageBucket: "nvpgames-landing.firebasestorage.app",
  messagingSenderId: "436897642123",
  appId: "1:436897642123:web:d2bd793484949bc9e6068e",
  measurementId: "G-M9WR5FYHPD"
};

let app: FirebaseApp | undefined;
let analyticsStarted = false;

function setFirebaseApp(nextApp: FirebaseApp) {
  app = nextApp;
  return app;
}

export async function initializeFirebaseAnalytics() {
  if (analyticsStarted || !import.meta.env.PROD) {
    return;
  }

  if (import.meta.env.VITE_FIREBASE_ANALYTICS === "false") {
    return;
  }

  const [{ initializeApp }, { getAnalytics, isSupported }] = await Promise.all([
    import("firebase/app"),
    import("firebase/analytics")
  ]);

  if (await isSupported()) {
    analyticsStarted = true;
    const currentApp = app ?? setFirebaseApp(initializeApp(firebaseConfig));
    getAnalytics(currentApp);
  }
}
